import { Map } from 'immutable';
import { defaultMemoize } from 'reselect';

import {
    getResourceError,
    isResourceFailed,
    isResourceLoading,
} from './common';

const isStaticsLoading = defaultMemoize(isResourceLoading);
const isStaticsFailed = defaultMemoize(isResourceFailed);
const getStatics = defaultMemoize((data) => data.get('data', new Map()));
const getStaticsError = defaultMemoize(getResourceError);

export {
    isStaticsFailed,
    isStaticsLoading,
    getStatics,
    getStaticsError,
};
